import React from 'react';
import classnames from 'classnames';
import { BrokerLoginModalWrapper, ModalItem, ModalButton } from './BrokerHeader.styled';

var BrokerLoginModal = function BrokerLoginModal(_ref) {
  var isModalActive = _ref.isModalActive,
      modalItems = _ref.modalItems;
  return /*#__PURE__*/React.createElement(BrokerLoginModalWrapper, {
    className: classnames({
      'is-open': isModalActive
    })
  }, modalItems && modalItems.map(function (_ref2) {
    var heading = _ref2.heading,
        description = _ref2.description,
        button = _ref2.button,
        button2 = _ref2.button2;
    return /*#__PURE__*/React.createElement(ModalItem, null, /*#__PURE__*/React.createElement("h5", null, heading), /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(ModalButton, {
      "aria-label": button.label,
      href: button.href,
      trackEventData: {
        action: button.action,
        category: button.category
      },
      target: button.target
    }, button.label), heading === 'Submit an Asset Loan application' && button2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ModalButton, {
      "aria-label": button2.label,
      href: button2.href,
      trackEventData: {
        action: button2.action,
        category: button2.category
      },
      target: button2.target
    }, button2.label)));
  }));
};

export default BrokerLoginModal;